<script>
export default {
  data() {
    return {
      items: [
        {
          name: 'admin-brokerage-list',
          title: this.$t('brokerage_nav.brokerage_list'),
        },
        {
          name: 'admin-brokerage-catalog',
          title: this.$t('brokerage_nav.brokerage_catalog'),
        },
        {
          name: 'admin-brokerage-catalog-relation-list',
          title: this.$t('brokerage_nav.brokerage_catalog_relation_list'),
        },
        {
          name: 'admin-brokerage-catalog-balance-list',
          title: this.$t('brokerage_nav.brokerage_catalog_balance_list'),
        },
        {
          name: 'admin-brokerage-catalog-share-list',
          title: this.$t('brokerage_nav.brokerage_catalog_share_list'),
        },
        {
          name: 'admin-brokerage-catalog-adjust-list',
          title: this.$t('brokerage_nav.brokerage_catalog_adjust_list'),
        },
      ],
    }
  },
}
</script>

<template>
  <ul
    v-if="$route.name !== 'admin-brokerage-list'"
    :class="$style.localNavigation"
  >
    <router-link
      v-for="{ name, title } in items"
      :key="name"
      :to="{ name, params: $route.params }"
      :active-class="$style.on"
      tag="li"
    >
      <a href="#" @click.prevent>{{ title }}</a>
    </router-link>
  </ul>
</template>

<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/admin.scss';
@import '@src/design/font.scss';
</style>
